<template>
  <div>
    <DiscardPopup v-model="showDiscardPopup" @cancel="popupCancel" @discard="close" />
    <SendMessageInput
      v-model="message"
      title="Reply to start the chat"
      :tips="tips"
      :label-name="`Reply to ${displayName}`"
      :loading="messageSendLoading"
      :validation-message="`This field is required`"
      @submit="sendMessage"
      @close="close"
      @close-draft="closeDraft"
    />
  </div>
</template>

<script lang="ts">
import SendMessageInput from '@/components/send_message_input/SendMessageInput.vue';
import DiscardPopup from '@/components/send_message_input/DiscardPopup.vue';
import { REPLY_TO_JOB_APPLICATION_WITH_SENDBIRD } from '@/graphql/applications/mutations';

export default {
  name: 'Interested',
  components: { SendMessageInput, DiscardPopup },
  inject: {
    navigateToNextApplication: { default: () => {} },
  },
  data() {
    return {
      message: '',
      messageSendLoading: false,
      showDiscardPopup: false,
    };
  },
  computed: {
    displayName(): string {
      return this.$store.getters['applications/applicationDetails'].sitter?.displayName || '';
    },
    tips(): string[] {
      return [
        `Tell ${this.displayName} why they’re a good fit for your job`,
        'Ask about their availability to set up a call or an in-person interview',
      ];
    },
  },
  methods: {
    close(): void {
      this.showDiscardPopup = false;
      this.message = '';
      this.$emit('close');
    },
    closeDraft(): void {
      this.showDiscardPopup = true;
    },
    popupCancel(): void {
      this.showDiscardPopup = false;
    },
    async sendMessage(message: string) {
      this.messageSendLoading = true;
      await this.replyToJobApplicationWithSendbird(message, this.$route.params.application_uuid);
      this.messageSendLoading = false;
    },
    async replyToJobApplicationWithSendbird(message: string, jobApplicationId: string): Promise<void> {
      await this.$apollo
        .mutate({
          mutation: REPLY_TO_JOB_APPLICATION_WITH_SENDBIRD,
          variables: {
            jobApplicationId,
            message,
          },
        })
        .then(async () => {
          const nextApplicationId = await this.$store.dispatch('applications/moveApplication', {
            applicationId: jobApplicationId,
            fromStatus: 'RECEIVED',
            toStatus: 'INTERESTED',
          });
          this.$store.dispatch('applications/showMessageSentNotification', 'Message sent and applicant moved to Interested');
          this.navigateToNextApplication(nextApplicationId);
        })
        .catch((error: any) => {
          console.error('GraphQL query error:', error);
        });
    },
  },
};
</script>
